interface UserSigninData {
    user?: {
        username?: string;
        first?: string;
        signinStatus?: string;
    }
}

export const isSecureURL = () => location.href.indexOf('secure.') > -1;
const isCheckOutURL = () => location.href.indexOf('givingCart.html') > -1;
const headerType = window?.document?.getElementById?.('mainHeader')?.dataset.headerType;

const isSecureOrCart = () =>
    isSecureURL() || headerType === 'cart';

export function toggleSignInOverlay(event?: Event | null, forceOverlay?: boolean, data?: UserSigninData) {
    if (!forceOverlay && !isCheckOutURL && isSecureOrCart()) {
        return;
    }

    toggleSignInOverlayInternal(data, event);
}

export function toggleCartSignInOverlay(forceOverlay: boolean, data?: UserSigninData) {
    if (!forceOverlay && isSecureOrCart()) {
        return;
    }

    toggleSignInOverlayInternal(data);
}

export function toggleContactFormSignInOverlay(forceOverlay: boolean, data?: UserSigninData) {
    if (!forceOverlay && isSecureOrCart()) {
        return;
    }

    toggleSignInOverlayInternal(data);
}

function toggleSignInOverlayInternal(data?: UserSigninData, event?: Event | null) {
    if (window.signinOverlay2Part) {
        if (event) {
            event.preventDefault();
        }

        const { username, first, signinStatus } = (data && data.user) || {};
        window.signinOverlay2Part.toggleSignin(username, first, signinStatus);
    }
}
